export default __webpack_public_path__ + "static/media/clothbagetc.74ad53f1.png";